export const environment = {
  production: false,
  apiUrl: 'https://xi5f-5y62-kbyr.n7e.xano.io/api',
  apiSuffix: ':dev',
  dataSource: 'dev',
  businessUrl: 'https://business-dev.luqta.io',
  siteUrl: 'https://luqta.io',
  firebaseConfig: {
    apiKey: "AIzaSyC2CTC9Yut75v2lptj8YGXQkWmKxf4d6to",
    authDomain: "luqta-50841.firebaseapp.com",
    projectId: "luqta-50841",
    storageBucket: "luqta-50841.firebasestorage.app",
    messagingSenderId: "104176712263",
    appId: "1:104176712263:web:1bb54a2e6b57608f268f62",
    measurementId: "G-J6M382CML7"
  },
  cms: {
    clientApi: 'https://xi5f-5y62-kbyr.n7e.xano.io/api:Zlmxhpzf:dev',
    clientHeaders: { 'x-data-source': 'dev' },
    licenseKey: 'XTRO-5ACE-7C0B-93E7-3FB5',
    highlightColor: '#5304fb'
  }
};


// ng build      Production                           (live)
// ng build --configuration=development                 dev
// ng build --configuration=production                  live
